import classNames from 'classnames';
import {observer} from 'mobx-react';
import React from 'react';

import {CartSliderMenuImpressionEvent, COMPONENT_VERSION} from '@udemy/cart';
import {Tracker, TrackImpression} from '@udemy/event-tracking';
import {useI18n} from '@udemy/i18n';
import {useUDData} from '@udemy/ud-data';

import {getConfig} from '../../config';
import {CheckoutButton} from '../checkout-button/checkout-button.react-component';
import styles from './cart-slider-menu.module.less';

export const CartSliderMenu = observer(() => {
    const udData = useUDData();
    const {gettext, interpolate, ngettext} = useI18n();
    const config = getConfig(gettext, interpolate, ngettext);

    if (udData.isGlobalMeContextLoading ?? true) return null;

    const trackImpression = () =>
        Tracker.publishEvent(
            new CartSliderMenuImpressionEvent(
                COMPONENT_VERSION.UDLITE as ConstructorParameters<
                    typeof CartSliderMenuImpressionEvent
                >[0],
            ),
        );

    return (
        <TrackImpression trackFunc={trackImpression}>
            <div
                className={classNames(
                    styles['slider-menu'],
                    styles['slider-menu__free-clp-overrides'],
                )}
            >
                <div className={styles['cta-button']}>
                    <CheckoutButton size={'large'} authNextUrl={config.urls.cartPage} />
                </div>
            </div>
        </TrackImpression>
    );
});
